export default "<dashboards-embed dashboards=\"\" parameters=\"params\"></dashboards-embed>";